import { DocumentNode, gql } from '@parkchirp/api-client';

export const GET_SUBSCRIPTION = gql`
  query getSubscription(
    $accountId: String
    $subscription_id: String
  ) {
    getSubscription(
      accountId: $accountId
      subscription_id: $subscription_id
    ) {
        payor {
          id
          readable_id
          type
          status
          contact_notes
          billing_firstname
          billing_lastname
          billing_phone
          billing_work_phone
          billing_email
          billing_emails {
              id
              payor_id
              email
          }
          billing_street
          billingAddressStreet2
          billing_city
          billing_state
          billing_zip
          info_name
          info_attn
          info_street
          info_city
          info_state
          info_zip
          cognito_sub
          wordpress_user_id
      }
      allowCreditCardPayments
      achDisabled
      auto_pay
      account_id
      subscription_name
      status
      subscription_invoice_notes
      id
      account_id
      mail_invoices
      email_invoices
      taxExempt
      autoInvoiceSetting
      autoApplyCredits
      numberOfParkingSpaces
      lateFees
      auto_pay
      tenantEnforceTermination
      tenantReservedSpaceEnabled
      hasPendingParkers
      tenantNonTenant
      billing_profile {
        id
        facility_id
        name
        validation_only
        facility {
          facility_name
          facility_number
          sublots {
            id
            name
          }
        }
        facilitySettings {
          facility_id
          admin_process_payments
          manage_recurring_payments
          edit_payment_options
          use_ach
          use_credit_card
          paymentProviderId
        }
      }
      paymentMethod {
        id
        token
      }
    }
  }
`;

export const GET_DRAFT_INVOICE = gql`
query getDraftInvoice(
  $invoiceId: String!
) {
  getDraftInvoice(
    invoiceId: $invoiceId
  ) {
    id,
    type,
    parkingPeriodMonth,
    parkingPeriodYear,
    readableId,
    dueOn,
    createdAt,
    notes,
    detailNotes,
    amount,
    balance,
    emailInvoice,
    mailInvoice,
    billingDate,
    createdByDailyReport,
    invoiceAttachments {
      name
      type
      data
    }
    subscription {
      id
      accountId
      billingProfileId
      subscriptionName
      manualInvoiceDueDateOffset
      taxExempt
      manualTaxExemptions { tax1 tax2 tax3 tax4 }
      subscriptionTaxExemptTaxes {
        taxNumber
        parkingPeriodYearExpiration
        parkingPeriodMonthExpiration
        effectiveStartDate
        adjustmentDateType
      }
      payor {
        infoName
        infoStreet
        infoCity
        infoState
        infoZip
      }
      billingProfile {
        facility {
          id
          facilityName
          facilityNumber
        }
      }
    }
    invoiceLineItems {
      id
      serviceDateStart
      serviceDateEnd
      feeQuantity
      dailyReportId
      lineItemEntries {
        id
        amount
        amountTax1
        amountTax2
        amountTax3
        amountTax4
        transactions {
          id
        }
      }
      fee {
        price
        tax1
        tax2
        tax3
        tax4
        quantity
      }
      rate {
        id
        name
        childDiscountAmount
        childDiscountType
      }
      parker {
        id
        first_name
        last_name
      }
      sublot {
        id
        name
      }
      feeHistory {
        id
        price
        tax1
        feeId
        tax2
        tax3
        tax4
        inputType
        inactiveDate
        taxCalculation
        productCode {
          id
          name
          code
        }
        rateCode {
          id
          name
          code
        }
        fee {
          feeName
          calculationType
          rateFees {
            rateId
          }
          feeType {
            name
            id
          }
        }
        taxTableTax1 {
          taxTableRates {
            percentageOfNet
          }
        }
        taxTableTax2 {
          taxTableRates {
            percentageOfNet
          }
        }
        taxTableTax3 {
          taxTableRates {
            percentageOfNet
          }
        }
        taxTableTax4 {
          taxTableRates {
            percentageOfNet
          }
        }
      }
    }
  }
}
`;

export const GET_FACILITY_V2 = gql`
    query getFacility(
        $facilityId: String!,
        $withSublots: Boolean,
        $tenantSubscriptionId: String
    ) {
        getFacility(
            facilityId: $facilityId,
            withSublots: $withSublots,
            tenantSubscriptionId: $tenantSubscriptionId
        ) {
            id
            facilityName
            facilityNumber
            wordpressPostId
            organizationId
            integration
            timezone
            accessSystemCredentials
            facilitySettings {
              usesDefaultRates
              maxActiveVehicles
              minActiveVehicles
            }
            sublots {
                id
                name
                primaryLot
            }
        }
    }
`;

export const GET_SUBSCRIPTION_V2 = gql`
  query getSubscriptionById(
    $subscriptionId: String!
  ) {
    getSubscriptionById(
      subscriptionId: $subscriptionId
    ) {
      mailInvoices
      manualInvoiceDueDateOffset
      subscriptionName
      emailInvoices
      taxExempt
      manualTaxExemptions { tax1 tax2 tax3 tax4 }
      tenantNonTenant
      tenantEnforceTermination
      billingProfile {
        facilityId
        facility {
          facilityName
          facilityNumber
        }
      }
      subscriptionTaxExemptTaxes {
        taxNumber
        parkingPeriodYearExpiration
        parkingPeriodMonthExpiration
        effectiveStartDate
        adjustmentDateType
      }
      manualInvoiceBillingProfile {
        id
        profileName
        dueDay
        billingDay
        billingDayInArrears
        dueDayInArrears
      }
      payor {
        infoName
        infoAttn
        infoStreet
        infoCity
        infoState
        infoZip
      }
    }
  }
`;

export const GET_SUBSCRIPTION_V2_FOR_DETAIL = gql`
  query getSubscriptionById(
    $subscriptionId: String!
    $facilityId: String
  ) {
    getSubscriptionById(
      subscriptionId: $subscriptionId
      facilityId: $facilityId
    ) {
      accountId
      accessSystemMeta
      autoApplyCredits
      autoInvoiceSetting
      creditCardFees
      defaultInvoiceBillingProfileId
      emailInvoices
      status
      id
      hasAcceptedMostRecentTerms
      subscriptionTermsAndConditionsAcceptance {
        methodOfAcceptance
        userIp
        acceptanceDate
        termsAndConditionsHistory {
          id
          text
          summary
        }
        user {
          firstName
          lastName
          email
        }
      }
      achAuthorizationAcceptances {
        id
        authorizationType
        methodOfAcceptance
        authorizationText
        operatorLegalName
        operatorAccountLast4
        operatorAbaLast4
        accountType
        amount
        effectiveDate
        recurrenceFrequency
        cancellationMethod
        revocationNoticeDays
        acceptedAt
        userAgent
        userIp
        user {
          firstName
          lastName
          email
        }
      }
      subscriptionSupportingDocuments {
        id
        fileName
        bucketPath
        createdAt
      }
      subscriptionInvoiceNotes
      lateFees
      mailInvoiceFees
      mailInvoices
      subscriptionName
      transactionFees
      taxExempt
      manualTaxExemptions { tax1 tax2 tax3 tax4 }
      residentNonResident
      residentUnit
      tenantNonTenant
      tenantName
      billingProfile {
        name
        facilityId
        facility {
          organizationId
          facilityName
          facilityNumber
          timezone
          facilitySettings {
            paymentProviderId
          }
            taxTableCity {
              taxTableTaxes {
                taxNumber
                name
              }
            }
        }
      }
      subscriptionTaxExemptTaxes {
          taxNumber
          parkingPeriodMonthExpiration
          parkingPeriodYearExpiration
          effectiveStartDate
          certificateId
          adjustmentDateType
          taxExemptCertificate {
            organizationType
            companyName
            issueState
            exemptionNumber
            filePath
            expirationDate
            createdAt
          }
      }
      hasPendingParkers
      manualInvoiceBillingProfile {
        id
        profileName
        dueDay
        billingDay
        billingDayInArrears
        dueDayInArrears
      }
      payor {
        billingFirstName
        billingLastName
        billingPhone
        billingCountryCode
        billingWorkPhone
        billingWorkCountryCode
        billingEmail
        billingEmails {
          id
          email
        }
        billingStreet
        billingAddressStreet2
        billingCity
        billingState
        billingZip
        cognitoSub
        contactNotes
        id
        infoAttn
        infoName
        infoStreet
        infoCity
        infoState
        infoZip
        readableId
        type
      }
    }
  }
`;

export const GET_SUBSCRIPTION_WITH_ORG_ID_V2 = gql`
  query getSubscriptionById(
    $subscriptionId: String!
  ) {
    getSubscriptionById(
      subscriptionId: $subscriptionId
    ) {
      mailInvoices
      emailInvoices
      billingProfile {
        facilityId
        facility {
          organizationId
          organizationSettings {
            requireProductAndRateCodes
          }
        }
      }
    }
  }
`;

export const GET_SUBSCRIPTION_ADDRESSES_V2 = gql`
  query listSubscriptionAddresses(
      $order: SortOrder,
      $filters: [Filter]
      $limit: Int!,
      $offset: Int!
  ) {
    listSubscriptionAddresses(
        order: $order,
        filters: $filters,
        limit: $limit,
        offset: $offset
    ) {
      subscriptions {
        id
        accountId
        subscriptionName
        status
        facilityId
        facilityNumber
        facilityName
        payorId
        pcStreet
        pcCity
        pcState
        pcZip
        pcPhone
        pcEmail
        billingAttn
        billingFirstName
        billingLastName
        billingStreet
        billingAddressStreet2
        billingCity
        billingState
        billingZip
        primaryContact
      }
      count
    }
  }
`;

export const LIST_SUBSCRIPTIONS_FROM_CACHE = gql`
  query listSubscriptionsFromCache(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
    $facilityId: String
  ) {
    listSubscriptionsFromCache(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      facilityId: $facilityId
      ) {
      count
      subscriptions {
          id
          facilityNumber
          facilityName
          recurringPayments
          recurringPaymentType
          accountId
          subId
          subType
          subStatus
          taxExempt
          manualTaxExemptions {
            tax1
            tax2
            tax3
            tax4
          }
          taxCertSaved
          taxCertExpiration
          name
          primaryContact
          primaryContactPhone
          primaryContactEmail
          billingProfileName
          mailInvoices,
          emailInvoices,
          accountBalance
          facilityId
          timezone
          validationOnly
          isUpdating
          residentNonResident
          residentUnit
          tenantNonTenant
          tenantName
          hasAcceptedMostRecentTerms
          batchNewParkers
          sendBatchInvoiceOn
        }
      }
  }
`;

export const GET_SUBSCRIPTIONS_CSV = gql`
    query getSubscriptionsCSV(
        $filters: [Filter]
        $order: SortOrder
        $facilityId: String
        $limit: Int
        $offset: Int
      ) {
        getSubscriptionsCSV(
            filters: $filters
            order: $order
            facilityId: $facilityId
            limit: $limit
            offset: $offset
        ) {
            url
        }
    }
`;

export const GET_CONTRACTS = gql`
  query listContracts(
    $filters: [Filter]
    $order: Order
    $limit: Int
    $offset: Int
    $special: Special
    $facilityId: String!
  ) {
    listContracts(
      filters: $filters
      order: $order
      limit: $limit
      offset: $offset
      special: $special
      facilityId: $facilityId
    ) {
      total
      offset
      contracts {
        id
        contractType
        documentType
        contractName
        ownerLLC
        startDate
        expirationDate
        filePath
        createdAt
        facility {
          id
          facility_name
          facility_number
          timezone
        }
      }
    }
  }
`;

export const GET_CONTRACT = gql`
  query getContract($keyName: String) {
    getContract(keyName: $keyName)
  }
`;

export const GET_FACILITY_CONTRACT_TYPE_V2 = gql`
query getFacility($facilityId: String!) {
    getFacility(facilityId: $facilityId) {
      contractType
    }
  }
`;

export const GET_PAYMENT_GROUP_BY_ID = gql`
  query getPaymentGroupById($groupId: Int!) {
    getPaymentGroupById(groupId: $groupId) {
      id
      amount
      paymentType
      paymentMetaId
      notes
      payments {
        paymentId
        transactionDate
        applicationDate
        type
        invoiceNumber
        creditId
        amount
        status
        creditBalance
        canBeReversed
        canBeUnapplied
        canBeRefunded
        creditReadableId
        applicationType
        creditEntryId
        invoiceId
        paymentBatchId
        facilityId
        user {
          email
          firstName
          lastName
        }
      }
      credits {
        paymentId
        transactionDate
        applicationDate
        type
        invoiceNumber
        creditId
        amount
        creditBalance
        canBeReversed
        canBeUnapplied
        applicationType
        creditReadableId
        creditEntryId
        invoiceId
        paymentBatchId
        facilityId
        user {
          email
          firstName
          lastName
        }
      }
    }
  }
`;

export const GET_FACILITY_SETTINGS = gql`
  query getFacilitySettings($facilityId: String!) {
    getFacilitySettings(facilityId: $facilityId) {
      earliestPaymentApplicationDate
      latestPaymentApplicationDate
      paymentApplicationMonths {
        month
        status
        year
      }
      futureMonthApplication
    }
  }
`;

export const GET_RECEIPT_V2 = gql`
  query getReceipt($groupId: Int!) {
    getReceipt(groupId: $groupId) {
      pdf
      fileName
    }
  }
`;

export const GET_FACILITIES = gql`
  query listFacilities(
    $limit: Int
    $offset: Int
    $order: facilityOrder
    $filters: [Filter]
    $for_admin_dashboard: Boolean
    $facility_id: String
    $special: Special
  ) {
    listFacilities(
      limit: $limit
      offset: $offset
      order: $order
      filters: $filters
      for_admin_dashboard: $for_admin_dashboard
      facility_id: $facility_id
      special: $special
    ) {
      total
      facilities {
        id
        uid
        facility_name
        city {
          id
          name
        }
        district {
          id
          name
          facilityBranch {
            id
            name
            facilityArea {
              id
              name
            }
          }
        }
        company_number
        facility_number
        timezone
        organization_id
        wordpress_post_id
        organization_id
        organization_settings {
          id
          name
        }
        billing_profiles {
          rates {
            online_start_date
          }
        }
        onlineStartDate
        onlineEndDate
        earliestPaymentApplicationDate
        latestPaymentApplicationDate
        lastAvailableBillingStartDate
        address
        contract_type
        capacity
        facility_type
        self_park
        valet
        gated_parking_hardware
        valet_parking_technology
        pay_by_phone_technology
        integration
        market
        accessSystemCredentials
        isIntegrationActive
        terminateActiveParkersDate
        pendingParkersStartDate
        facilitySettings {
          paymentProviderId
          autoSendReceipts
          usesDefaultRates
        }
        facilityPaymentSettings {
          id
          setting
          value
        }
      }
    }
  }
`;

export const GET_INVOICE = gql`
  query getInvoice($readable_id: String) {
    getInvoice(readable_id: $readable_id) {
      id
      subscription {
        billing_profile {
          facility_id
        }
      }
    }
  }
`;

export const LIST_INVOICES_FOR_INVOICE_PAGE = gql`
  query listInvoicesForInvoicePage(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
    $facilityId: String
    $getDrafts: Boolean
  ) {
    listInvoicesForInvoicePage(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      facilityId: $facilityId
      getDrafts: $getDrafts
    ) {
      count
      invoices {
        id
        invoiceNumber
        facilityId
        facilityNumber
        facilityName
        invoiceDate
        invoiceLocalDate
        parkingPeriod
        parkingPeriodMonth
        parkingPeriodYear
        dueDate
        invoiceType
        accountId
        subscriberId
        subscriptionName
        amount
        balance
        mailInvoice
        createdByDailyReport
        billingDate
      }
    }
  }
`;

export const LIST_CREDITS_FROM_CACHE = gql`
  query listCreditsFromCache(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
    $facilityId: String
  ) {
    listCreditsFromCache(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      facilityId: $facilityId
    ) {
      count
      credits {
        id
        creditReadableId
        balance
        createdAt
        accountId
        amount
        balance
        applicationType
        subscriptionName
        subId
        facilityNumber
        facilityName
        facilityId
        type
        paymentBatchId
      }
    }
  }
`;

export const GET_CREDITS_CSV = gql`
  query getCreditsCSV(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
    $facilityId: String
  ) {
    getCreditsCSV(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      facilityId: $facilityId
    ) {
       url
    }
  }
`;

export const LIST_FACILITY_AREAS: any = gql`
  query listFacilityAreas(
    $organizationId: Int!
    $limit: Int
    $offset: Int
    $filters: [Filter]
    $order: Order
    $special: Special
    $includePrimary: Boolean
  ) {
    listFacilityAreas(
      organizationId: $organizationId
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      special: $special,
        includePrimary: $includePrimary
    ) {
      total
      limit
      offset
      facilityAreas {
        id
        name
        code
      }
    }
  }
`;
export const LIST_FACILITY_BRANCHES: any = gql`
  query listFacilityBranches(
    $organizationId: Int!
    $limit: Int
    $offset: Int
    $filters: [Filter]
    $order: Order
    $special: Special
    $includePrimary: Boolean
  ) {
    listFacilityBranches(
      organizationId: $organizationId
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      special: $special,
        includePrimary: $includePrimary
    ) {
      total
      limit
      offset
      facilityBranches {
        id
        name
        code
        areaId
        facilityArea {
          name
          code
        }
      }
    }
  }
`;

export const LIST_FACILITY_OWNERS = gql`
  query listFacilityOwners(
    $facilityId: String!
  ) {
    listFacilityOwners(
      facilityId: $facilityId
    ) {
      user {
        email
        userId
      }
    }
  }
`;

export const LIST_FACILITY_DISTRICTS: any = gql`
  query listFacilityDistricts(
    $organizationId: Int!
    $limit: Int
    $offset: Int
    $filters: [Filter]
    $order: Order
    $special: Special
    $includePrimary: Boolean
  ) {
      listFacilityDistricts(
        organizationId: $organizationId,
        limit: $limit,
        offset: $offset,
        filters: $filters,
        order: $order,
        special: $special,
        includePrimary: $includePrimary
        ) {
            total
            limit
            offset
            facilityDistricts {
              id
              name
              code
              branchId
              facilityBranch {
                id
                name
                code
                areaId
                facilityArea {
                  id
                  name
                  code
                  organizationId
                }
            }
          }
        }
  }
`;

export const LIST_GL_CODES_V2 = gql`
  query listGLCodes(
    $organizationId: Int!
    $filters: [Filter]
    $order: SortOrder
    $limit: Int
    $offset: Int
  ) {
    listGLCodes(
      organizationId: $organizationId
      filters: $filters
      order: $order
      limit: $limit
      offset: $offset
    ) {
      count
      glCodes {
        id
        rateCode
        rateCodeId
        productCode
        productCodeId
        contractType
        glCode
        glType
        createdAt
        facilityName
        facilityNumber
        timezone
        createdAt
      }
    }
  }
`;

export const GET_GL_CODES_CSV = gql`
  query getGLCodesCSV(
    $organizationId: Int!
    $filters: [Filter]
    $order: SortOrder
  ) {
    getGLCodesCSV(
      organizationId: $organizationId
      filters: $filters
      order: $order
    ) {
       url
    }
  }
`;

export const GET_ORGANIZATION_SETTINGS_BY_ORG_ID: any = gql`
    query getOrganizationSettingsByOrgId(
        $id: Int!
    ) {
        getOrganizationSettingsByOrgId(
            id: $id
        ) {
            requireGLRevProductCode
            alertConfigurations {
              type
              emails
            }
            isParkerTypeRequired
        }
    }
`;

export const FETCH_PUT_SIGNED_URL: any = gql`
    query depositDocumentsPutUrl(
      $id: String!,
      $basePath: String!,
      $contentType: String!,
  ) {
    depositDocumentsPutUrl(
        id: $id,
        contentType: $contentType,
        basePath: $basePath,
      ) {
        url
      }
  }
`;

export const GET_DEPOSIT_DOCUMENTS: any = gql`
    query getDepositDocuments(
      $paymentBatchId: Int!,
  ) {
    getDepositDocuments(
        paymentBatchId: $paymentBatchId,
      ) {
        id
        createdAt
        description
        path
        paymentBatchId
        contentType
      }
  }
`;

export const GET_DEPOSIT_DOCUMENT_SIGNED_URL: any = gql`
    query getDepositDocumentSignedUrl(
      $path: String!,
  ) {
    getDepositDocumentSignedUrl(
      path: $path,
      ) {
        url
      }
    }
`;

export const LIST_BILLING_PROFILE_NAMES = gql`
    query listBillingProfiles(
        $limit: Int,
        $offset: Int,
        $filters: [Filter],
        $order: Order,
        $isForAdminDashboard: Boolean,
        $facilityId: String
    ) {
        listBillingProfiles(
            limit: $limit,
            offset: $offset,
            filters: $filters,
            order: $order,
            isForAdminDashboard: $isForAdminDashboard,
            facilityId: $facilityId
        ) {
            billing_profiles {
                id
                name
            }
        }
    }
`;

export const LIST_TAX_TABLE_CITIES_BY_ORGANIZATION_ID: any = gql`
    query listTaxTableCitiesByOrganizationId(
        $organization_id: Int,
    ) {
        listTaxTableCitiesByOrganizationId(organization_id: $organization_id) {
            id,
            name,
            state,
            active,
            timezone,
            organization_id,
            taxes {
                id,
                name,
                active,
                current_tax,
                city_id,
            }
      }
    }
`;

export const GET_MY_ACCOUNT_FACILITY_SETTINGS: any = gql`
    query getMyAccountFacilitySettings(
        $facilityId: String!,
    ) {
      getMyAccountFacilitySettings(facilityId: $facilityId) {
        showParkerTermination
        showParkerAddition
      }
    }
`;

export const LIST_FEES_HISTORY_V2 = gql`
    query listFeesHistoryFromView(
      $feeType: String
      $limit: Int
      $offset: Int
      $order: SortOrder
      $filters: [Filter]
      $groupRows: Boolean
    ) {
      listFeesHistoryFromView(
            feeType: $feeType
            limit: $limit
            offset: $offset
            order: $order
            filters: $filters
            groupRows: $groupRows
        ) {
              total
              data {
                id
                feeId
                feeType
                feeName
                facilityName
                facilityNumber
                facilityTimezone
                taxCalculation
                feeInputType
                tax1
                tax2
                tax3
                tax4
                price
                rateCode
                productCode
                startDate
                taxApplied
                inactiveDate
                feeInactiveDate
                inputType
                taxTableRate1
                status
                taxTableRate2
                taxTableRate3
                net
                gross
                taxTableRate4
                tax1Percentage
                tax2Percentage
                tax3Percentage
                tax4Percentage
                active
                deviceType
                accessDeviceRequired
                vehicleType
                calculationType
                recurring
              }
        }
    }
`;

export const LIST_ALL_ACTIVE_FEES_V2 = gql`
    query listAllActiveFees(
      $facilityId: String!
    ) {
      listAllActiveFees(
            facilityId: $facilityId
        ) {
            id
            feeName
            feeAccessDeviceType {
                  accessDeviceTypeId
                  accessDeviceType {
                    type
                  }
            }
            feeTypeId
            feeType {
                name
            }
            feesHistory {
              feeId
              productCode {
                id
                code
              }
              rateCode {
                id
                code
              }
            }
        }
    }
`;

export const LIST_PARKERS_FOR_MANUAL_INVOICES_V2 = gql`
    query listParkersForManualInvoices(
      $subscriptionId: String!
      $parkingPeriodMonth: String!
      $parkingPeriodYear: Int!
    ) {
      listParkersForManualInvoices(
          subscriptionId: $subscriptionId
          parkingPeriodMonth: $parkingPeriodMonth
          parkingPeriodYear: $parkingPeriodYear
        ) {
            id
            firstName
            lastName
            group
            parkerSublotHistory {
              sublot {
                id
                name
              }
            }
            rate {
                id
                name
                childRateMetadata {
                    discountAmount
                    discountType
                }
                rateFees {
                  fee {
                    id
                    feeName
                    calculationType
                    feeTypeId
                    feeType {
                        name
                    }
                    feesHistory {
                      id
                      price
                      tax1
                      tax2
                      tax3
                      tax4
                      inputType
                      taxCalculation
                      productCode {
                        id
                        name
                        code
                      }
                      rateCode {
                        id
                        name
                        code
                        description
                      }
                      taxTableTax1 {
                        taxTableRates {
                          percentageOfNet
                        }
                      }
                      taxTableTax2 {
                        taxTableRates {
                          percentageOfNet
                        }
                      }
                      taxTableTax3 {
                        taxTableRates {
                          percentageOfNet
                        }
                      }
                      taxTableTax4 {
                        taxTableRates {
                          percentageOfNet
                        }
                      }
                    }
                  }
                }
            }
            parkerVehicles {
              license
            }
        }
    }
`;

export const LIST_FEES_FOR_VALIDATION_V2 = gql`
  query listFeesForValidation(
    $facilityId: String!
    $parkingPeriod: String!
  ) {
    listFeesForValidation(
          facilityId: $facilityId
          parkingPeriod: $parkingPeriod
      ) {
        fees {
          id
          feeName
          calculationType
          feeTypeId
          feeType {
            name
          }
          feesHistory {
            id
            price
            tax1
            tax2
            tax3
            tax4
            startDate
            inactiveDate
            inputType
            taxCalculation
            productCode {
              id
              name
              code
            }
            rateCode {
              id
              name
              code
              description
            }
            taxTableTax1 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax2 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax3 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax4 {
              taxTableRates {
                percentageOfNet
              }
            }
          }
        }
        facilityHasOtherFeesOutsideOfParkingPeriod
      }
    }
`;

export const LIST_MANUAL_INVOICE_BILLING_SETTINGS = gql`
  query listManualInvoiceBillingSettings(
    $facilityId: String!
  ) {
    listManualInvoiceBillingSettings(
          facilityId: $facilityId
      ) {
        id
        profileName
        billingDayInArrears
        dueDayInArrears
        dueDay
        billingDay
      }
  }
`;

export const LIST_FEES_FOR_MANUAL_V2 = gql`
  query listFeesForManual(
    $facilityId: String!
    $parkingPeriod: String!
  ) {
    listFeesForManual(
          facilityId: $facilityId
          parkingPeriod: $parkingPeriod
      ) {
        fees {
          id
          feeName
          calculationType
          feeTypeId
          feeType {
            name
          }
          rateFees {
            rateId
          }
          feesHistory {
            id
            price
            tax1
            tax2
            tax3
            tax4
            startDate
            inactiveDate
            inputType
            taxCalculation
            productCode {
              id
              name
              code
            }
            rateCode {
              id
              name
              code
              description
            }
            taxTableTax1 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax2 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax3 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax4 {
              taxTableRates {
                percentageOfNet
              }
            }
          }
        }
        facilityHasOtherFeesOutsideOfParkingPeriod
      }
    }
`;

export const LIST_FEES_FOR_OTHER_MANUAL_INVOICES_V2 = gql`
  query listFeesForOtherManualInvoices(
    $facilityId: String!
    $feeTypeId: Int!
    $parkingPeriod: String!
  ) {
    listFeesForOtherManualInvoices(
          facilityId: $facilityId
          feeTypeId: $feeTypeId
          parkingPeriod: $parkingPeriod
      ) {
        fees {
          id
          feeName
          calculationType
          feeTypeId
          feeType {
              name
          }
          feesHistory {
            id
            price
            tax1
            tax2
            tax3
            tax4
            inputType
            taxCalculation
            startDate
            inactiveDate
            productCode {
              id
              name
              code
            }
            rateCode {
              id
              name
              code
              description
            }
            taxTableTax1 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax2 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax3 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax4 {
              taxTableRates {
                percentageOfNet
              }
            }
          }
        }
        facilityHasOtherFeesOutsideOfParkingPeriod
    }
  }
`;

export const GET_FEE_V2 = gql`
    query getFee(
      $feeId: String!
    ) {
      getFee(
        feeId: $feeId
        ) {
            id
            feeName
            calculationType
            createdFromDefaultRate
            feeType {
              name
            }
            facility {
              facilityNumber
              facilityName
              timezone
              id
              organizationId
              cityId
              organizationSettings {
                requireProductAndRateCodes
              }
            }
            feeAccessDeviceType {
              accessDeviceType {
                type
                id
              }
            }
            vehicleTypeFee {
              vehicleType {
                id
                name
              }
            }
            feesHistory {
              id
              startDate
              inactiveDate
              tax1
              tax2
              tax3
              tax4
              inputType
              rateCode {
                id
                name
                code
              }
              taxTableTax1 {
                id
                name
                taxNumber
                taxTableRates {
                  effectiveDate
                  percentageOfNet
                  createdAt
                }
              }
              taxTableTax2 {
                id
                name
                taxNumber
                taxTableRates {
                  effectiveDate
                  percentageOfNet
                  createdAt
                }
              }
              taxTableTax3 {
                id
                name
                taxNumber
                taxTableRates {
                  effectiveDate
                  percentageOfNet
                  createdAt
                }
              }
              taxTableTax4 {
                id
                name
                taxNumber
                taxTableRates {
                  effectiveDate
                  percentageOfNet
                  createdAt
                }
              }
              productCode {
                id
                name
                code
              }
              price
              taxCalculation
              hasBeenUsed
            }
        }
    }
`;

export const LIST_FEES_FOR_BILLING_PROFILES_V2 = gql`
    query listFeesForBillingProfiles(
      $facilityId: String!
    ) {
      listFeesForBillingProfiles(
            facilityId: $facilityId
        ) {
            id
            feeName
            calculationType
            feeTypeId
            feeType {
                name
            }
        }
    }
`;

export const GET_RATE_BY_ID_V2 = gql`
query getRateDetailsById(
  $rateId: ID!
) {
  getRateDetailsById(rateId: $rateId) {
    id
    description
    name
    active
    display
    passType
    accessHours
    location
    firstMonthProration
    firstMonthProrationDay
    taxExempt
    billingProfileId
    requireCarInfo
    createdAt
    updatedAt
    deletedAt
    monthsToSellInAdvance
    accessDeviceMessage
    accessLevelCode
    onlineStartDate
    onlineEndDate
    parentRateId
    lateFeeDay
    isSoldOut
    sublot {
      id
      name
    }
    childRateMetadata {
      startDate
      endDate
      discountType
      discountAmount
    }
    billingProfile {
      name
      paymentDueDay
      facility {
        id
        organizationId
        facilityName
        facilityNumber
        timezone
        onlineStartDate
        onlineEndDate
        integration
        facilitySettings {
          usesDefaultRates
        }
      }
    }
    rateFees {
      feeId
      rateId
      fee {
        id
        feesHistory {
          tax1
          tax2
          tax3
          tax4
          tax1TaxTableId
          tax2TaxTableId
          tax3TaxTableId
          tax4TaxTableId
          inputType
          taxCalculation
          productCodeId
          rateCodeId
          productCode {
            code
          }
          rateCode {
            code
          }
        }
        feeName
        feeTypeId
        feeType {
          name
        }
      }
    }
    rateAccessDevices {
      feeId
      rateId
      required
      fee {
        feeName
        feeTypeId
        feeType {
          name
        }
        feesHistory {
          productCode {
            code
          }
          rateCode {
            code
          }
        }
      }
      accessDeviceTypeId
      accessDeviceType {
        type
      }
    }
    salesLimits {
      month
      year
      limit
    }
    promoCodes {
      text
      useLimit
      expiresOn
    }
    externalApiRates {
      integration
    }
    futureChildRateDiscounts {
      id
      rateId
      discountType
      discountAmount
      endDate
      startDate
    }
  }
}
`;

export const GET_FEE_TYPE_ID = gql`
    query getFeeTypeId(
      $feeType: String!
    ) {
      getFeeTypeId(
        feeType: $feeType
      ) {
        id
      }
    }
`;

export const GET_PRODUCT_CODES = gql`
    query getProductCodesByOrganizationId(
      $organizationId: Int!
    ) {
      getProductCodesByOrganizationId(
        organizationId: $organizationId
      ) {
        id
        name
      }
    }
`;

export const GET_RATE_CODES = gql`
    query getRateCodesByOrganizationId(
      $organizationId: Int!
    ) {
      getRateCodesByOrganizationId(
        organizationId: $organizationId
      ) {
        id
        name
      }
    }
`;

export const GET_TAX_TABLE_TAXES_BY_CITY_ID_V2 = gql`
    query getTaxRatesByCityId($cityId: ID!, $type: String) {
      getTaxRatesByCityId(cityId: $cityId, type: $type) {
            id
            name
            taxNumber
            taxTableRates {
              percentageOfNet
              effectiveDate
            }
        }
    }
`;

export const GET_CARRYOVER_FEE_TYPES = gql`
query getCarryoverFeeTypes {
   getCarryoverFeeTypes {
        id
        name
    }
}
`;

export const GET_USER_PAYMENT_METHODS = gql`
  query getUserPaymentMethods(
      $userId: String!
      $subscriptionId: String
  ) {
    getUserPaymentMethods(
        userId: $userId
        subscriptionId: $subscriptionId
    ) {
      gpiCards {
        id
        token
        type
        last4
        expMonth
        expYear
      }
      gpiBankAccounts {
        id
        token
        accountType
        last4
        firstName
        lastName
        businessName
      }
    }
  }
`;

export const GET_USERS = gql`
query getUsers(
  $limit: Int,
  $offset: Int,
  $order: SortOrder,
  $filters: [Filter],
) {
    getUsers(
      limit: $limit,
      offset: $offset,
      order: $order,
      filters: $filters,
    ) {
        users {
          id
          cognitoSub
          firstName
          lastName
          email
          facilities {
            id
          }
          subscriptions {
            id
            subscriptionName
            accountId
          }
          role {
            id
            name
            displayName
          }
        }
        total
    }
}
`;

export const GET_USERS_CSV = gql`
query getUsersCSV(
  $filters: [Filter]
  $order: SortOrder
) {
  getUsersCSV(
      filters: $filters
      order: $order
  ) {
      url
  }
}
`;

export const GET_USER = gql`
query getUser(
  $id: String!,
) {
    getUser(
      id: $id,
    ) {
        id
        firstName
        lastName
        email
        cognitoSub
        facilities {
          id
          name
        }
        role {
          id
          name
          organizationId
          isAssignedFacilities
        }
    }
}
`;

export const LIST_ORGANIZATIONS = gql`
query listOrganizations {
    listOrganizations
     {
      id
      organizationId
      name
    }
}
`;

export const GET_DASHBOARD_ACCESS_CONFIG = gql`
query getDashboardAccessConfig {
    getDashboardAccessConfig
}
`;

export const GET_GITBOOK_JWT = gql`
  query getGitbookJWT {
    getGitbookJWT {
      token
    }
  }
`;

export const LIST_ORGANIZATIONS_BY_ID = gql`
query listOrganizationsById(
  $organizationId: Int!,
) {
    listOrganizationsById(
      organizationId: $organizationId,
    ) {
      id
      name
      code
      facilityBranches {
        id
        name
        code
        facilityDistricts {
          id
          name
          code
          facilities {
            id
            facilityName
            facilityNumber
          }
        }
      }
    }
}
`;

export const LIST_ORGANIZATIONS_BY_USER_ID = gql`
query listOrganizationsByUserId(
  $userId: String!,
) {
    listOrganizationsByUserId(
      userId: $userId,
    ) {
      FacilityAreas
      FacilityBranches
      FacilityDistricts
      facilities
    }
}
`;

export const GET_ORGANIZATION_ROLES = gql`
  query getOrganizationRoles($organizationId: Int) {
    getOrganizationRoles(organizationId: $organizationId) {
      id
      name
      displayName
      isAssignedFacilities
    }
  }
`;

export const GET_PAYMENT_APPLICATION_MONTHS = gql`
 query getPaymentApplicationMonths($facility_id: String!) {
        getPaymentApplicationMonths(facility_id: $facility_id) {
            id,
            month,
            year,
            status
        }
    }
`;

export const GET_PAYMENT_BATCH_V2 = gql`
query getPaymentBatch($paymentBatchId: Int!) {
    getPaymentBatch(paymentBatchId: $paymentBatchId) {
        id
        totalWriteOffAmount
        writeOffDetails {
            id
            invoiceId
            amount
            paymentType
            invoice { readableId }
            subscription { accountId }
            facility { facilityName facilityNumber }
        }
        subtotalCash
        subtotalCreditsApplied
        subtotalCreditsCreated
        grandTotal
        status
        createdAt
        postedAt
        batchNumber
        rejectionReason
        createdByUser {
          firstName
          lastName
        }
        updatedByUser {
          firstName
          lastName
        }
        paymentBatchDetails {
            id
            allocation
            canSubmit
            creditAppliedTax1
            creditAppliedTax2
            creditAppliedTax3
            creditAppliedTax4
            writeOffRemainingBalance
            invoice {
                readableId
                balance
                dueOn
                subscription {
                    subscriptionName
                    accountId
                    billingProfile {
                        facilityId
                    }
                }
            }
            subscription {
                id
                subscriptionName
                accountId
                billingProfile {
                    name
                }
            }
            facility {
                facilityName
                facilityNumber
                timezone
            }
            credit {
                id
                readableId
                applicationType
            }
            invoiceId
            amount
            paymentType
            applicationType
            creditApplicationDate
            applicationDate
            paymentMetaId
            creditAmount
            creditId
            facilityId
            subscriptionId
            notes
            applyTo
            createdAt
        }
    }
}`;

export const GET_ADJUSTMENT_BATCH = gql`
query getAdjustmentBatch($adjustmentBatchId: Int!) {
    getAdjustmentBatch(adjustmentBatchId: $adjustmentBatchId) {
        id
        totalAdjustmentAmount
        status
        createdAt
        postedAt
        batchNumber
        adjustmentBatchDetails {
            id
            canSubmit
            lineItemId
            subscription {
                accountId
            }
            invoice {
              id
              readableId
              balance
            }
            amount
            type
            facilityId
            subscriptionId
            notes
        }
    }
}`;

export const GET_SUBSCRIPTION_FOR_PAYMENT_APP = gql`
  query getSubscriptionForPaymentApp($accountId: String!) {
    getSubscriptionForPaymentApp(accountId: $accountId) {
      id
      subscription_name
      billing_profile {
        facility_id
        facility {
            facility_name
            facility_number
            timezone
            earliestPaymentApplicationDate
            latestPaymentApplicationDate
            paymentApplicationMonths {
                month
                status
                year
            }
          }
          facilitySettings {
            future_month_application
            organization_id
            accounting_method
          }
        }
        invoices {
            balance
            created_at
            due_on
            id
            readable_id
            total_amount
            total_tax_1
            total_tax_2
            total_tax_3
            total_tax_4
            other_pending_batches {
              batchId
              status
            }
        }
        credit {
            id
            balance
            application_type
            created_at
            payment_id
            readable_id
            other_pending_batches {
              batchId
              status
            }
            payment_meta {
                check_number
            }
            credit_entries {
                amount
                amount_tax_1
                amount_tax_2
                amount_tax_3
                amount_tax_4
                application_date
            }
        }
    }
  }
`;

export const GET_SUBSCRIPTION_FOR_ADJUSTMENT_APP = gql`
  query getSubscriptionForPaymentApp($accountId: String!) {
    getSubscriptionForPaymentApp(accountId: $accountId) {
      id
      subscription_name
      billing_profile {
        facility_id
        facility {
            facility_name
            facility_number
          }
          facilitySettings {
            organization_id
          }
        }
        invoices {
            balance
            created_at
            due_on
            id
            readable_id
            total_amount
            total_tax_1
            total_tax_2
            total_tax_3
            total_tax_4
            other_pending_batches {
              batchId
              status
            }
        }
    }
  }
`;

export const GET_FACILITY_PAYMENT_TYPES = gql`
  query getFacilityPaymentTypes(
      $facilityId: String!,
      $usageType: String
  ) {
        getFacilityPaymentTypes(
            facilityId: $facilityId,
            usageType: $usageType
        ) {
            paymentTypes {
                paymentTypeName
            }
        }
    }`;

export const SEARCH_BY_SUB_NAME_PAYMENT_APP = gql`
  query searchBySubNamePaymentApp($searchTerm: String!) {
    searchBySubNamePaymentApp(searchTerm: $searchTerm) {
      id
      subscriptionName
      accountId
      billingProfile {
        facility {
          facilityName
          facilityNumber
          id
        }
      }
    }
  }
`;

export const GET_ALL_INVOICE_TEMPLATES = gql`
  query getAllInvoiceTemplates {
    getAllInvoiceTemplates {
      id
      invoiceType
      templateName
    }
  }
`;

export const GET_ORGANIZATION_INVOICE_TEMPLATES = gql`
query getOrganizationInvoiceTemplates($organizationId: Int!) {
  getOrganizationInvoiceTemplates(organizationId: $organizationId) {
    id
    invoiceType
    templateName
  }
}
`;

export const GET_FACILITY_INVOICE_TEMPLATES = gql`
query getFacilityInvoiceTemplates($facilityId: String!) {
  getFacilityInvoiceTemplates(facilityId: $facilityId) {
    id
    invoiceType
    templateName
  }
}
`;

export const GET_FACILITY_TERMS_AND_CONDITIONS = gql`
query getFacilityTermsAndConditions($facilityId: String!) {
  getFacilityTermsAndConditions(facilityId: $facilityId) {
    termsAndConditions {
      termsAndConditionsHistory {
        id
        text
        summary
      }
    }
  }
}
`;

export const GET_INVOICE_PDF_PAYMENT_APP = gql`
  query getInvoicePDFFromMyAccount($invoiceId: String!) {
        getInvoicePDFFromMyAccount(invoiceId: $invoiceId) {
          pdfUrl
        }
    }`;

export const GET_EXTERNAL_API_ENDPOINTS = gql`
    query getExternalApiEndpoints {
      getExternalApiEndpoints {
        id
        httpEndpoint
        endpoint
        description
      }
}`;

export const GET_USER_EXTERNAL_API_FACILITY_ENDPOINTS = gql`
query getUserExternalApiFacilityEndpoints($userId: String!) {
    getUserExternalApiFacilityEndpoints(userId: $userId) {
        id
        userId
        facilityId
        facilityName
        endpointId
    }
}`;

export const GET_SUBSCRIPTION_ADDRESSES_CSV = gql`
  query getSubscriptionAddressesCsv(
      $order: SortOrder,
      $filters: [Filter],
  ) {
      getSubscriptionAddressesCsv(
          order: $order,
          filters: $filters,
      ) {
          url
      }
  }
`;

export const GET_RATES_CSV = gql`
  query getRatesCsv(
      $order: SortOrder,
      $filters: [Filter],
  ) {
      getRatesCsv(
          order: $order,
          filters: $filters,
      ) {
          url
      }
  }
`;

export const GET_DEFAULT_RATES_CSV = gql`
  query getDefaultRatesCsv(
      $order: SortOrder,
      $filters: [Filter],
  ) {
      getDefaultRatesCsv(
          order: $order,
          filters: $filters,
      ) {
          url
      }
  }
`;

export const LIST_TAX_TABLE_CITIES_BY_ORGANIZATION_ID_BY_TAXES: any = gql`
    query listTaxTableCitiesByOrganizationIdByTaxes(
        $organizationId: Int!,
        $filters: [Filter],
        $order: [SortOrder],
        $limit: Int,
        $offset: Int,
    ) {
        listTaxTableCitiesByOrganizationIdByTaxes(
          organizationId: $organizationId,
          filters: $filters,
          order: $order,
          limit: $limit,
          offset: $offset
        ) {
            id
            name
            cityId
            cityName
            cityState
            active
            currentTax
            type
      }
    }
`;

export const LIST_TAX_TABLE_CITIES_BY_ORGANIZATION_ID_BY_CITIES: any = gql`
    query listTaxTableCitiesByOrganizationIdByCities(
        $organizationId: Int!,
        $filters: [Filter],
        $order: [SortOrder],
        $limit: Int,
        $offset: Int,
      ) {
        listTaxTableCitiesByOrganizationIdByCities(
          organizationId: $organizationId,
          filters: $filters,
          order: $order,
          limit: $limit,
          offset: $offset
        ) {
            id
            name
            state
            active
            timezone
            organizationId
      }
    }
`;

export const GET_TAX_TABLE_CSV = gql`
  query getTaxTableCsv(
      $order: [SortOrder],
      $filters: [Filter],
      $organizationId: Int!,
      $taxReportType: TaxReportType!
  ) {
      getTaxTableCsv(
          order: $order,
          filters: $filters,
          organizationId: $organizationId,
          taxReportType: $taxReportType
      ) {
          url
      }
  }
`;

export const GET_PRODUCT_AND_RATE_CODES_CSV = gql`
    query getProductAndRateCodesCsv(
        $filters: [Filter],
        $organizationId: Int!,
        $order: SortOrder,
        $codeType: String!
    ) {
        getProductAndRateCodesCsv(
          filters: $filters,
          organizationId: $organizationId,
          order: $order,
          codeType: $codeType
        ) {
            url
        }
    }
`;

export const LIST_RATE_CODES: any = gql`
  query listRateCodes(
    $organizationId: Int!
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder!
  ) {
    listRateCodes(
      organizationId: $organizationId
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
    ) {
      total
      rateCodes {
        id
        name
        code
        description
      }
    }
  }
`;

export const LIST_PRODUCT_CODES: any = gql`
  query listProductCodes(
    $organizationId: Int!
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder!
  ) {
    listProductCodes(
      organizationId: $organizationId
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
    ) {
      total
      productCodes {
        id
        name
        code
        description
      }
    }
  }
`;

export const LIST_HOURLY_SESSIONS: DocumentNode = gql`
  query listHourlySessions(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: [SortOrder]
  ) {
    listHourlySessions (
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
    ) {
      total
      sessions {
        id,
        hash,
        barcode,
        status,
        startTime,
        endTime,
        type,
        zone {
          id
          name
          facility {
            facilityName,
            facilityNumber,
            timezone
          }
        }
        user {
          firstName,
          lastName,
          email,
          phone
        }
        vehicle {
          type,
          license,
          state,
          make,
          model
        },
        transactionStatus,
        transactionState,
        transactionType,
        net,
        taxes,
        grossRefundable,
        tiers {
          feeName,
          rates {
            rateName
          }
        }
        validationMethods {
        	text,
	        validation {
	        	id,
	         	name
	        }
        }
        source,
        sourceUrl
        entryTime
        exitTime
        claimStatus
        lprEnterEvent {
			id
			data
			provider
			eventTimestamp
			createdAt
        }
      }
    }
  }
`;

export const LIST_HOURLY_SESSIONS_CSV: DocumentNode = gql`
  query listHourlySessionsCSV(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: [SortOrder]
    $timezone: String
  ) {
    listHourlySessionsCSV (
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      timezone: $timezone
    ) {
      url
    }
  }
`;

export const LIST_HOURLY_ACCOUNTING: DocumentNode = gql`
  query listHourlyAccounting(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: [SortOrder]
    $timezone: String
  ) {
    listHourlyAccounting (
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      timezone: $timezone
    ) {
      total
      sessions {
        type
        id
        timestamp
        sessionId
        facilityName
        facilityNumber
        facilityTimezone
        zoneId
        zoneName
        firstName
        lastName
        licensePlate
        sessionStart
        sessionEnd
        transactionType
        paymentType
        amount
        fees
        taxes
        gross
        tierName
        validationMethods {
        	text,
	        validation {
	        	id,
	         	name
	        }
        }
        ccLast4
        ccBatch
        ccApprovalCode
      }
    }
  }
`;

export const GET_HOURLY_RECEIPT = gql`
  query getHourlyReceipt(
      $hourlySessionId: Int
  ) {
      getHourlyReceipt(
          hourlySessionId: $hourlySessionId
      ) {
          net
          tax
          gross
          grossRefunds
          grossRefundable
      }
  }
`;

export const GET_FACILITY_FEES = gql`
  query getFacilityFeesForCityChange($facilityId: String!) {
    getFacilityFeesForCityChange(facilityId: $facilityId) {
      id
      feeName
      feeTypeId
      feeType {
        name
      }
      feeAccessDeviceType {
        accessDeviceTypeId
      }
      calculationType
      feesHistory {
        taxCalculation
        startDate
        inactiveDate
        taxTableTax1 {
          taxTableRates {
            percentageOfNet
          }
        }
        taxTableTax2 {
          taxTableRates {
            percentageOfNet
          }
        }
        taxTableTax3 {
          taxTableRates {
            percentageOfNet
          }
        }
        taxTableTax4 {
          taxTableRates {
            percentageOfNet
          }
        }
      }
    }
  }
`;

export const LIST_PARKING_SESSION_CHANGELOG: DocumentNode = gql`
  query listParkingSessionChangelog($sessionId: String!) {
    listParkingSessionChangelog(sessionId: $sessionId) {
      id
      paymentId
      paymentProcessedAt
      sessionEnd
      sessionId
      sessionStart
      total
      transactionStatus
      type
      zoneId
    }
  }
`;

export const GET_PRESIGNED_URL = gql`
    query getPresignedUrl(
        $bucket: String!,
        $s3Key: String!
    ) {
        getPresignedUrl (
            bucket: $bucket,
            s3Key: $s3Key
        ) {
            presignedUrl
        }
    }
`;

export const LIST_PARKING_SESSION_CHANGELOG_PAGINATED: DocumentNode = gql`
  query listParkingSessionChangelogPaginated(
    $limit: Int
    $exclusiveStartKey: ChangelogExclusiveStartKeyInput
    $filters: [Filter]
    $report: String
  ) {
    listParkingSessionChangelogPaginated(
      limit: $limit
      exclusiveStartKey: $exclusiveStartKey
      filters: $filters
      report: $report
    ) {
      changelog {
        id
        sessionId
        sessionStart
        sessionEnd
        zoneId
        transactionStatus
        total
        createdAt
      }
      lastEvaluatedKey {
        id
        changelogGroup
        sessionEnd
      }
      url
    }
  }
`;

export const LIST_USER_FACILITIES: DocumentNode = gql`
  query listUserFacilities(
     $facilityId: String!
  ) {
    listUserFacilities(
      facilityId: $facilityId
    ) {
      data {
        id
        firstName
        lastName
        email
        role
        organization
        facilityName
        facilityNumber
      }
    }
  }
`;

export const GET_HOURLY_VALIDATIONS: DocumentNode = gql`
  query getHourlyValidations(
    $limit: Int
    $offset: Int
    $filters: [Filter]
    $order: [SortOrder]
    $category: [String]
  ) {
    getHourlyValidations(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      category: $category
    ) {
      data {
        id
        name
        city {
        	id
         	name
        }
        modifier {
        	type
         	value
          	rate {
           		id
             	name
            }
        }
        startsOn
        expiresOn
        createdAt
        updatedAt
        organizationName
        category
      }
      total
    }
  }
`;

export const GET_HOURLY_VALIDATION: DocumentNode = gql`
	query getHourlyValidation(
		$id: String!
	) {
		getHourlyValidation(
			id: $id
		) {
			id
			name
			active
			city {
				id
				name
				timezone
			}
			modifier {
				id
				rateId
				rate {
					deletedAt
				}
				type
				timeOffType
				value
				timeMinimum
				timeMaximum
				priceMinimum
				priceMaximum
				useProgressiveRates
				useEventRates
				useOverlayRates
				createdAt
				updatedAt
			}
			zones {
				id
				zoneId
				default
			}
			methods {
				id
				active
				useCount
				useLimit
			}
			startsOn
			expiresOn
			createdAt
			updatedAt
			organizationId
			organizationName
			category
		}
	}
`;

export const UPDATE_HOURLY_VALIDATION: DocumentNode = gql`
	mutation updateHourlyValidation(
		$validation: HourlyValidationInput
	) {
		updateHourlyValidation(
			validation: $validation
		)
	}
`;

export const DELETE_HOURLY_VALIDATION: DocumentNode = gql`
	mutation deleteHourlyValidation(
		$id: String!
	) {
		deleteHourlyValidation(
			id: $id
		)
	}
`;

export const LIST_HOURLY_VALIDATION_METHODS: DocumentNode = gql`
	query listHourlyValidationMethods(
		$validationId: String!
		$method: [String]
	) {
		listHourlyValidationMethods(
			validationId: $validationId
			method: $method
		) {
			id
			validationId
			active
			method
			description
			text
			useLimit
			useCount
			startsOn
			expiresOn
			createdAt
			updatedAt
		}
	}
`;

export const UPDATE_HOURLY_VALIDATION_METHOD: DocumentNode = gql`
	mutation updateHourlyValidationMethod(
		$method: HourlyValidationMethodInput
	) {
		updateHourlyValidationMethod(
			method: $method
		)
	}
`;

export const DELETE_HOURLY_VALIDATION_METHOD: DocumentNode = gql`
	mutation deleteHourlyValidationMethod(
		$id: String!
	) {
		deleteHourlyValidationMethod(
			id: $id
		)
	}
`;

export const GET_FACILITY_ZONES_BY_CITY: DocumentNode = gql`
  query getFacilityZonesByCity($cityId: String!) {
    getFacilityZonesByCity(cityId: $cityId) {
      id
      facilityName
      facilityNumber
      facilityZones {
        id
        name
      }
    }
  }
`;

export const LIST_HOURLY_RATES_BY_CITY: DocumentNode = gql`
  query listHourlyRatesByCity($cityId: String!, $category: String!) {
    listHourlyRatesByCity(cityId: $cityId, category: $category) {
      id
      name
    }
  }
`;

export const LIST_VALIDATIONS_BY_ZONE_ID: DocumentNode = gql`
	query listValidationsByZoneId($zoneId: String!, $category: [String]) {
		listValidationsByZoneId(zoneId: $zoneId, category: $category) {
			id
			name
			category
			modifier {
				type
			}
			city {
				id
				name
			}
			startsOn
			expiresOn
			createdAt
			updatedAt
			organizationName
		}
	}
`;

export const GET_FACILITY_PAYMENT_SETTINGS = gql`
    query getFacilityPaymentSettings(
        $limit: Int
        $offset: Int
        $filters: [Filter]
        $order: [SortOrder]
    ) {
        getFacilityPaymentSettings(
            limit: $limit
            offset: $offset
            filters: $filters
            order: $order
        ) {
            paymentSettings {
               facilityId
               facilityName
               facilityNumber
               paymentProvider {
                   id
               }
               settings {
                   setting
                   value
               }
            }
            total
        }
    }
`;

export const GET_FACILITY_PAYMENT_SETTING_HISTORY = gql`
    query getFacilityPaymentSettingHistory(
        $facilityId: String!
    ) {
        getFacilityPaymentSettingHistory(
            facilityId: $facilityId
        ) {
            history {
                id
                createdAt
                facilityPaymentSettingId
                setting
                updatedBy
                value
            }
            total
        }
    }
`;

export const LIST_FACILITIES_V2 = gql`
    query listFacilities(
        $limit: Int!
        $offset: Int!
        $filters: [Filter]
        $order: SortOrder
    ) {
        listFacilities(
            limit: $limit
            offset: $offset
            filters: $filters
            order: $order
        ) {
            id
            facilityName
            facilityNumber
            cityId
            districtId
            companyNumber
            address
            timezone
            organizationId
            wordpressPostId
            contractType
            capacity
            facilityType
            selfPark
            valet
            organizationSettings {
              name
            }
            facilitySettings {
              autoSendReceipts
              paymentProviderId
              integrationEnabled
              autoAccessEnabled
              autoAccessDay
              autoAccessDayType
              autoAccessTime
              enableReservedSpaceInventory
            }
            facilityDistricts {
              id
              name
              facilityBranches {
                id
                name
                facilityArea {
                  id
                  name
                }
              }
            }
            taxTableCity {
              id
              name
            }
            gatedParkingHardware
            valetParkingTechnology
            payByPhoneTechnology
            integration
            reservationIntegration
            market
            onlineStartDate
            onlineEndDate
            earliestPaymentApplicationDate
            latestPaymentApplicationDate
            terminateActiveParkersDate
            pendingParkersStartDate
            lastAvailableBillingStartDate
            isIntegrationActive
            isReservationIntegrationActive
            facilityPaymentSettings {
              setting
              value
            }
            accessSystemCredentials
            reservationAccessSystemCredentials
        }
    }
`;

export const LIST_FACILITIES_COUNT = gql`
    query listFacilitiesCount(
        $filters: [Filter]
    ) {
      listFacilitiesCount(
          filters: $filters
      ) {
          total
    }
  }
`;

export const GET_FACILITIES_CSV = gql`
    query getFacilitiesCSV(
        $filters: [Filter]
        $order: SortOrder
      ) {
        getFacilitiesCSV(
            filters: $filters
            order: $order
        ) {
            url
        }
      }
`;

export const GET_FACILITIES_WITHOUT_PAYMENT_SETTINGS = gql`
    query getFacilitiesWithoutPaymentSettings(
        $searchText: String
    ) {
        getFacilitiesWithoutPaymentSettings(
            searchText: $searchText
        ) {
            facilities {
                facilityId
                facilityName
                facilityNumber
                paymentProviderId
            }
        }
    }
`;

export const LIST_HOURLY_TERMS_AND_CONDITIONS: DocumentNode = gql`
  query listHourlyTermsAndConditions(
    $organizationId: Int!,
    $filters: [Filter],
    $order: [SortOrder],
    $limit: Int,
    $offset: Int
  ) {
    listHourlyTermsAndConditions(
      organizationId: $organizationId,
      filters: $filters,
      order: $order,
      limit: $limit,
      offset: $offset
    ) {
      data {
        id
        name
        cityId
        cityName
        text
        default
        createdAt
        updatedAt
        createdBy
        updatedBy
      }
      total
    }
  }
`;

export const GET_FACILITY_SETTINGS_FOR_PAYMENT_APPLICATION = gql`
    query getFacilitySettings($facility_id: String!) {
        getFacilitySettings(facility_id: $facility_id) {
            accounting_method
            future_month_application
        }
    }
`;

export const GET_ORGANIZATION_SETTINGS_BY_FACILITY_ID = gql`
    query getOrganizationSettingsByFacilityId($facilityId: String!) {
        getOrganizationSettingsByFacilityId(facilityId: $facilityId) {
            manualInvoicesUseBillingSettings
            isParkerTypeRequired
        }
    }
`;

export const LIST_VALIDATED_PARKING_SESSIONS = gql`
    query listValidatedParkingSessions(
        $filters: [Filter]
        $order: [SortOrder]
        $limit: Int
        $offset: Int
        $report: String
        $timezone: String
    ) {
        listValidatedParkingSessions(
            filters: $filters
            order: $order
            limit: $limit
            offset: $offset
            report: $report
            timezone: $timezone
        ) {
            url
            sessions {
              id
              hash
              category
              facilityName
              facilityNumber
              facilityTimezone
              zoneName
              zoneId
              timestamp
              net
              taxes
              gross
              validation
		      validationId
		      validationMethod
              promoCode
              sessionStart
              sessionEnd
            }
            total
        }
    }
`;
